import React, {useEffect, useState} from "react";
import Axios from "axios";
import {mainUrl} from "../../../common/common";
import {Button, Col, Form, FormGroup, Modal, Row, Table, Spinner, Dropdown} from "react-bootstrap";
import {CardBody, CardHeader, CardTitle, Input} from "reactstrap";
import toast, {Toaster} from "react-hot-toast";

export default function Program(headers) {
    const [dataForm, setDataForm] = React.useState({});
    const [programModal, setProgramModal] = React.useState(false);
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const [recordId, setRecordId] = React.useState(0);
    const [list, setList] = React.useState([]);

    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        fetchList();
    }, []);
    const fetchList = async () => {
        const {data} = await Axios.get(mainUrl + "getProgram", headers);
        const lists = data;
        setList(lists);
        setIsLoading(true);
    };
    const addProgram = async (e) => {
        e.preventDefault();
        await Axios.post(mainUrl + "addProgram", {
            id: e.target.program_id.value,
            name: e.target.program_name.value,
            department_id: e.target.department_id.value,
            description: e.target.program_description.value,

            duration: e.target.duration.value,
            monthly_fee: e.target.monthly_fee.value,
            admission_fee: e.target.admission_fee.value,
            material_fee: e.target.material_fee.value,
            examination_fee: e.target.examination_fee.value,

        }, headers).then(res => {
            if (e.target.id.value == 0) {
                notifySuccess(' Added Successfully.');
            } else {
                notifySuccess(' Updated Successfully.');
            }
            setList(res.data);
            setProgramModal(false);
        }).catch(function (error) {
            notifyError(error.response.data.message);
            setProgramModal(false);
        });
    };


    const notifyError = (message) => toast.error(message, {
        duration: 6000,
    });
    const notifySuccess = (message) => toast.success(message, {
        duration: 6000,
    });
    return (
        <>

            <Row>
                <Col md="3"></Col>
                <Col className="pr-3" md="6">
                    {isLoading === false ? (
                        <div className="text-center">
                            <Spinner animation="border" variant="info"/>
                        </div>
                    ) : (
                        <div>
                            <AddItem dataForm={dataForm}/>
                            <TableData/>
                        </div>
                    )}
                </Col>
            </Row>
        </>
    );

    function DeleteItem() {

        const onDeleteRecord = async (e) => {
            e.preventDefault();
            await Axios.post(mainUrl + "deleteProgram", {
                id: recordId
            }, headers).then(res => {
                notifySuccess("Successfully deleted");
                const lists = res.data;
                setList(lists);
            }).catch((error) => {
                notifyError(error.response.data.message);

            });
            setRecordId(0);
            setShowDeleteModal(false);
        }

        return (
            <>
                <Modal show={showDeleteModal} backdrop="static" size="lg" onHide={() => setShowDeleteModal(false)}>
                    <form onSubmit={(e) => onDeleteRecord(e)}>
                        <Modal.Header>
                            <div className="modal-profile">
                                <h2>Confirmation</h2>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="pr-3">
                                <Col md="12">
                                    Are you sure you want to delete?
                                </Col>
                            </Row>
                        </Modal.Body>
                        <div className="modal-footer">
                            <Button title="Close"
                                    className="btn-simple"
                                    type="button"
                                    variant="link"
                                    onClick={() => setShowDeleteModal(false)}>
                                Close
                            </Button>
                            <Button title="Yes , I am sure" className="btn-round" color="danger" type="submit">
                                Yes
                            </Button>
                        </div>
                    </form>
                </Modal>
            </>
        );
    }

    function AddItem(prop) {


        const [departmentList, setDepartmentList] = React.useState([]);

        useEffect(() => {
            departList();
            setTimeout(async () => {
                if (prop.dataForm.department_id) {
                    if (document.getElementById('department_id')) {
                        document.getElementById('department_id').value = prop.dataForm.department_id;
                    }
                }

            }, 1000);

        }, []);
        const departList = async () => {
            const {data} = await Axios.get(mainUrl + "getDepartment", headers);
            const lists = data;
            setDepartmentList(lists);
            setIsLoading(true);
        };

        return (
            <>
                <Modal show={programModal} backdrop="static" size="lg" onHide={() => setProgramModal(false)}>
                    <Form onSubmit={(e) => addProgram(e)}>
                        <Modal.Header className="justify-content-center">
                            <div className="modal-profile">
                                New Program
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="pr-3">
                                <Input hidden={true} required name="program_id" id="program_id" defaultValue={prop.dataForm.id}
                                       type="hidden"/>

                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Department <span className="text text-danger">*</span></label>
                                        <select required name="department_id" id='department_id'
                                                defaultValue={prop.dataForm.department_id}
                                                className="form-control" title="Select position">
                                            <option value=""></option>
                                            {departmentList.map((e) => (
                                                <option key={e.id}
                                                        value={e.id}>{e.name}</option>
                                            ))}
                                        </select>
                                    </FormGroup>
                                </Col>

                            </Row>
                            <Row>
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Program Name <span className="text text-danger">*</span></label>
                                        <Input required name="program_name" id="program_name"
                                               defaultValue={prop.dataForm.name}
                                               placeholder="Program name" title="Program name" type="text"/>
                                    </FormGroup>
                                </Col>
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Duration <span className="text text-danger">*</span></label>
                                        <Input required name="duration" id="duration"
                                               placeholder="Duration" title="Duration"
                                               defaultValue={prop.dataForm.duration} type="number"/>
                                    </FormGroup>
                                </Col>
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Monthly fee <span className="text text-danger">*</span></label>
                                        <Input required name="monthly_fee" id="monthly_fee"
                                               placeholder="Monthly fee" title="Monthly fee"
                                               defaultValue={prop.dataForm.monthly_fee} type="number"/>
                                    </FormGroup>
                                </Col>
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Admission fee <span className="text text-danger">*</span></label>
                                        <Input required name="admission_fee" id="admission_fee"
                                               placeholder="Admission fee" title="Admission fee"
                                               defaultValue={prop.dataForm.admission_fee} type="number"/>
                                    </FormGroup>
                                </Col>
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Material fee <span className="text text-danger">*</span></label>
                                        <Input required name="material_fee" id="material_fee"
                                               placeholder="Material fee" title="Material fee name"
                                               defaultValue={prop.dataForm.material_fee} type="number"/>
                                    </FormGroup>
                                </Col>
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Examination fee <span className="text text-danger">*</span></label>
                                        <Input required name="examination_fee" id="examination_fee"
                                               placeholder="Examination fee " title="Examination fee "
                                               defaultValue={prop.dataForm.examination_fee} type="number"/>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <FormGroup>
                                        <label>Description <span className="text text-danger">*</span></label>
                                        <textarea className="form-control" placeholder="description . . ."
                                                  defaultValue={prop.dataForm.description}  name="program_description" id="program_description"></textarea>
                                    </FormGroup>
                                </Col>
                            </Row>

                        </Modal.Body>
                        <div className="modal-footer">
                            <Button title="Close"
                                    className="btn-simple"
                                    type="button"
                                    variant="link"
                                    onClick={() => setProgramModal(false)}>
                                Close
                            </Button>
                            <Button title="Insert & update  Record" className="btn-round" color="danger" type="submit">
                                Add
                            </Button>
                        </div>
                    </Form>
                </Modal>
            </>
        );
    }

    function TableData() {
        let no = 1;
        return (
            <>
                <DeleteItem/>
                <Row>
                    <Col md="12">
                        <div className="card-user">
                            <CardHeader>
                                <CardTitle className="mr-4 ml-4">
                                    <div className="row">

                                        <div className="ml-end">
                                            <Button title="Add New Record" className="btn-success" variant="primary"
                                                    onClick={() => {
                                                        setRecordId(0);
                                                        setDataForm({
                                                            "id":"0",
                                                            "department_id":"0",
                                                            "program_name":"",
                                                            "duration":"12",
                                                            "monthly_fee":"0",
                                                            "admission_fee":"0",
                                                            "examination_fee":"0",
                                                            "material_fee":"0",
                                                            "description":"",
                                                        });
                                                        setProgramModal(true)
                                                    }}>
                                                <span className="nc-icon nc-simple-add"/>
                                            </Button>
                                        </div>
                                    </div>
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Table>
                                    <thead className="text-primary">
                                    <tr>
                                        <th>No</th>
                                        <th>Department</th>
                                        <th>Program Name</th>
                                        <th className="text-right">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {list.map((e) => (
                                        <tr key={e.id}>
                                            <td>{no++}</td>
                                            <td style={{width: "50%"}}>{e.department_name}</td>
                                            <td style={{width: "50%"}}>{e.name}</td>

                                            <td style={{whiteSpace: "nowrap"}} className="text-right">
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="outline-info" id="dropdown-basic">
                                                        <span className="nc-icon nc-bullet-list-67"/>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Button title="Update & Detail View Record"
                                                                onClick={async () => {
                                                                    setDataForm(e);
                                                                    await setProgramModal(true);
                                                                    setTimeout(() => {
                                                                        // document.getElementById('program_name').value = e.name;
                                                                        // document.getElementById('program_id').value = e.id;
                                                                        // document.getElementById('department_id').value = e.department_id;
                                                                        // document.getElementById('program_description').value = e.description;
                                                                    }, 1000);
                                                                }} className="btn-round dropdownlist" variant="light"
                                                                type="Button">
                                                            <span className="nc-icon nc-paper text-info"/>&nbsp;&nbsp;
                                                            Update & Detail View Record
                                                        </Button>
                                                        <br/>
                                                        <Button title="Delete Record" onClick={() => {
                                                            setRecordId(e.id);
                                                            setShowDeleteModal(true);
                                                        }} className="btn-round dropdownlist" variant="light"
                                                                type="Button">
                                                            <span
                                                                className="nc-icon nc-simple-delete text-info"/>&nbsp;&nbsp;
                                                            Delete Record
                                                        </Button>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}
